<div class="select-common" [class]="class" (mouseleave)="outSelectValue($event)" [ngClass]="{'active': showDropDown}">
    <input  type="text" *ngIf="!isWarning" class="drop-toggle btn flat inp-select-focus form-control" [title]="!util.isNullOrEmpty(itemText) ? itemText : ''"
        [(ngModel)]="itemText" 
        (keydown)="onKeyDownEvent($event)"
        (focus)="activeSelectFocus($event)"
        (click)="togglebutton($event)"
        [ngClass]="{'active': showDropDown}"
        [readonly]='true' [placeholder]="placeholder"
        [disabled]='isDisabled'
        [id]="inpId">
    <div *ngIf="isWarning" [(ngModel)]="itemText" class="drop-toggle btn flat inp-select-focus"
        (keydown)="onKeyDownEvent($event)"
        (focus)="activeSelectFocus($event)"
        (click)="togglebutton($event)"
        [ngClass]="{'active': showDropDown}"
        [readonly]='true' [placeholder]="placeholder"
        [disabled]='isDisabled'
        [id]="inpId">
            <span *ngIf="itemText==null || itemText.trim()==''"></span>
            <span *ngIf="itemText==='ー' ">ー</span>
            <span *ngIf="itemText!=='ー' && itemText!==null && itemText!==''"style="color: #fdec96"  >
                <app-icon-warning *ngIf="itemText !== '99'" [(icon)]="itemText" style="color: #ffc715;"></app-icon-warning>
                <div class="icon-img icon-note active" *ngIf="itemText == '99'"></div>
            </span>
    </div>
        
    <div class="drop-show scrollbar" *ngIf="!isWarning" [ngClass]="{'scroll-box ': lstItem.length >=10, 'active': showDropDown, 'fadeShow': fadeLst, 'top': placementTop}">
        <div *ngFor="let it of lstItem; index as i" >
            <button [title]="it?.value" (click)="selected(it)" (keydown)="onActionEvent($event, it)"  [ngClass]="{'active': it?.active, 'focus': it?.focus}">
                {{it.value}}
            </button>
        </div>
    </div>
    <div class="drop-show scrollbar" *ngIf="isWarning" [ngClass]="{'scroll-box ': lstItem.length >=10, 'active': showDropDown, 'fadeShow': fadeLst, 'top': placementTop}">
        <div *ngFor="let it of lstItem; index as i" >
            <button [title]="it?.value" *ngIf="it==null||it.value==null|| it.value == '' || it.value == 'ー' " (click)="selected(it)" (keydown)="onActionEvent($event, it)"  [ngClass]="{'active': it?.active, 'focus': it?.focus}">
                {{it.value}}
            </button>
            <button [title]="it?.value" *ngIf="it!=null && it.value!=null&&it.value != ''&& it.value != 'ー' " (click)="selected(it)" (keydown)="onActionEvent($event, it)"  [ngClass]="{'active': it?.active, 'focus': it?.focus}">
                <span style="color: #fdec96"  >
                    <app-icon-warning *ngIf="it.value !== '99'" [(icon)]="it.value"></app-icon-warning>
                    <div class="icon-img icon-note active" *ngIf="it.value == '99'"></div>
                </span>
            </button>
        </div>
    </div>
  </div>